import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-import-from-bank-dialog',
  templateUrl: './import-from-bank-dialog.component.html',
  styleUrls: ['./import-from-bank-dialog.component.css']
})
export class ImportFromBankDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialog) { }

  ngOnInit(): void {
  }


  uploadDocumentsClick() {
    this.dialogRef.closeAll();
  }

}
